import { useEffect } from 'react'
import Navbar from './Navbar.jsx'
import Hero from './Hero.jsx'
import Despre from './Despre.jsx'
import Trailer from './Trailer.jsx'
import Gallery from './Gallery.jsx'
import Final from './Final.jsx'
import Footer from './Footer.jsx'

const App = () => {
    useEffect(() => {
        const q = (s) => document.querySelector(s)
        // nav: fundal solid la scroll
        const onScroll = () => { const n = q('#nav'); if (n) n.classList.toggle('scrolled', window.scrollY > 40) }
        window.addEventListener('scroll', onScroll, { passive: true })

        // reveal secțiuni la scroll (textul apare lin)
        const io = new IntersectionObserver(es => es.forEach(e => {
            if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target) }
        }), { threshold: 0.12 })
        document.querySelectorAll('.reveal').forEach((el, i) => { el.style.transitionDelay = (i % 6) * 60 + 'ms'; io.observe(el) })

        return () => { window.removeEventListener('scroll', onScroll); io.disconnect() }
    }, [])

    return (
        <>
            <Navbar />
            <span id="top"></span>
            <Hero />
            <Despre />
            <Gallery />
            <Final />
            <Footer />
            <Trailer />
        </>
    )
}

export default App
